import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import './permission' // permission control
import store from "./store"
import vueMeta from 'vue-meta'  // 生成<meta> 标签的
// 国际化
import i18n from './lang'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(vueMeta)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})

// use添加i18n
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})




// WEBPACK FOOTER //
// ./src/main.js